import { render, staticRenderFns } from "./BlogCategory.vue?vue&type=template&id=691f8c7c&scoped=true"
import script from "./BlogCategory.vue?vue&type=script&lang=js"
export * from "./BlogCategory.vue?vue&type=script&lang=js"
import style0 from "./BlogCategory.vue?vue&type=style&index=0&id=691f8c7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691f8c7c",
  null
  
)

export default component.exports